export const darkTheme = {
  name: 'dark',

  colors: {
    // Backgrounds
    background: '#121816',
    backgroundSecondary: '#1A221E',
    surface: '#1E2823',
    sidebar: '#0E1311',

    // Text
    textPrimary: '#F2F5F3',
    textSecondary: '#C5D0C9',
    textMuted: '#8A9A91',
    textInverse: '#121816',

    // Borders
    borderSubtle: '#24302A',
    borderDefault: '#2E3A34',
    borderStrong: '#3F4F46',

    // Brand / Actions — Ireland green + Chile red
    primary: '#3DDC97',
    primaryHover: '#2FBF80',
    accent: '#E11D48',
    accentHover: '#BE123C',
    success: '#3DDC97',
    warning: '#F59E0B',
    error: '#E11D48',
  },

  typography: {
    fontFamily: 'Poppins, system-ui, sans-serif',

    h1: {
      fontSize: '2rem',
      fontWeight: 'bold',
      lineHeight: 1.2,
      color: 'textPrimary',
    },

    h2: {
      fontSize: '1.75rem',
      fontWeight: 'bold',
      lineHeight: 1.3,
      color: 'textPrimary',
    },

    h3: {
      fontSize: '1.5rem',
      fontWeight: 'regular',
      lineHeight: 1.4,
      color: 'textPrimary',
    },

    h4: {
      fontSize: '1.25rem',
      fontWeight: 'regular',
      lineHeight: 1.4,
      color: 'textPrimary',
    },

    h5: {
      fontSize: '1rem',
      fontWeight: 'regular',
      lineHeight: 1.5,
      color: 'textPrimary',
    },

    h6: {
      fontSize: '0.875rem',
      fontWeight: 'regular',
      lineHeight: 1.5,
      color: 'textPrimary',
    },

    subtitle: {
      fontSize: '1.125rem',
      fontWeight: 'regular',
      lineHeight: 1.6,
      color: 'textSecondary',
    },

    body1: {
      fontSize: '1rem',
      fontWeight: 'regular',
      lineHeight: 1.6,
      color: 'textSecondary',
    },

    body2: {
      fontSize: '0.875rem',
      fontWeight: 'regular',
      lineHeight: 1.5,
      color: 'textSecondary',
    },

    caption: {
      fontSize: '0.75rem',
      fontWeight: 'regular',
      lineHeight: 1.4,
      color: 'textMuted',
    },

    jumbo: {
      fontSize: '3.5rem',
      fontWeight: 'bold',
      lineHeight: 1.1,
      color: 'textPrimary',
    },
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    xxxl: '64px',
  },

  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },

  shadows: {
    sm: '0 1px 2px rgba(0,0,0,0.05)',
    md: '0 4px 6px rgba(0,0,0,0.1)',
    lg: '0 10px 15px rgba(0,0,0,0.15)',
  },
}
